(function () {
    'use strict';

    $('a[data-slug="tools-refresh"]').on('click', function (e) {
        e.preventDefault();

        var href = $(this).attr('href');

        swal(
            {
                title: 'Are you sure?',
                text: 'This process will refresh the cached countries, locations, terms & conditions. data. It usually take 1-2 minutes.',
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'btn-danger',
                confirmButtonText: 'Go ahead!',
                closeOnConfirm: false,
            },
            function () {
                swal('Please wait...');

                location.href = href;
            }
        );
    });

    $('a[data-slug="tools-refresh-location-translations"]').on('click', function (e) {
        e.preventDefault();

        var href = $(this).attr('href');

        swal(
            {
                title: 'Are you sure?',
                text: 'This process will refresh the translated location names data. It usually take 1-2 minutes.',
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'btn-danger',
                confirmButtonText: 'Go ahead!',
                closeOnConfirm: false,
            },
            function () {
                swal('Please wait...');

                location.href = href;
            }
        );
    });

    $('a[data-slug="tools-refresh-opening-hours"]').on('click', function (e) {
        e.preventDefault();

        var href = $(this).attr('href');

        swal(
            {
                title: 'Are you sure?',
                text: 'This process will refresh the opening hours for all locations. It usually take 1-2 minutes.',
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'btn-danger',
                confirmButtonText: 'Go ahead!',
                closeOnConfirm: false,
            },
            function () {
                swal('Please wait...');

                location.href = href;
            }
        );
    });
})();



// WEBPACK FOOTER //
// ./resources/scripts/portal/pages/tools/refresh.js